/**************************************************
 * Nombre:       BarraPc
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import logo from '../../Recursos/logo_blanco.svg'
import {SECCIONES} from "../../Constantes";
import {useNavigate} from "react-router";

const BarraPc = () => {
    const navigate = useNavigate();

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, color: '#fff', py: 4}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={4} sx={{justifyContent: 'flex-start'}}>
                            <img src={logo} width={250} height={'auto'} onClick={() => navigate('/Home')}
                                 style={{cursor: 'pointer'}}/>
                        </Grid>

                        <Grid container size={4} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'space-between'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                {SECCIONES.map((item, index) => (
                                    <Typography
                                        sx={{
                                            fontWeight: 500,
                                            fontSize: 16,
                                            borderBottom: 2,
                                            borderColor: '#ffffff00',
                                            //mb: -2,
                                            cursor: 'pointer',
                                            transition: 'all .2s ease-in-out',
                                            "&:hover": {
                                                borderColor: '#fff',
                                            }
                                        }}
                                    >{item}</Typography>
                                ))}

                            </Grid>
                        </Grid>

                        <Grid container size={4} sx={{justifyContent: 'flex-end'}} spacing={2}>
                            <Button variant={'text'} sx={{color: '#fff'}}>Registrate</Button>

                            <Button>Inicia Sesion</Button>
                        </Grid>


                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default BarraPc  